import { render, staticRenderFns } from "./CashflowCategoryOpenCard.vue?vue&type=template&id=3bfc1172&scoped=true&"
import script from "./CashflowCategoryOpenCard.vue?vue&type=script&lang=js&"
export * from "./CashflowCategoryOpenCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bfc1172",
  null
  
)

export default component.exports